import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { CatalogProductCard } from '@web/widgets/product-card/type/product-card-widget.type';
import { type CatalogCategory } from '@web/widgets/product-card/type/product-card-widget.type';

export const ProductCatalogActions = createActionGroup({
    source: 'Catalog',
    events: {
        'Load catalog content': emptyProps(),
        'Load categories request': emptyProps(),
        'Load catalog content success': props<{ categories: CatalogCategory[]; products: CatalogProductCard[] }>(),
        'Load categories success': props<{ categories: CatalogCategory[] }>(),
        'Load categories failure': props<{ error: string }>(),
        'Load products request': props<{ categoryId: number; search: string; offset: number; limit: number }>(),
        'Load products success': props<{ products: CatalogProductCard[]; total: number }>(),
        'Load products failure': props<{ error: string }>(),
        'Set tariff expired': props<{ isTariffExpired: boolean }>(),
        'Set category': props<{ category: number }>(),
        'Load category by id': props<{ categoryId: number }>(),
        'Load category by id success': emptyProps(),
        'Load category by id failure': emptyProps(),
    },
});

export default ProductCatalogActions;
